import { TinaMarkdownContent } from 'tinacms/dist/rich-text';

export const useTinaMarkdownContent = (value: TinaMarkdownContent, fallback?: TinaMarkdownContent): TinaMarkdownContent | null => {
    return value?.children?.length ? value : (fallback?.children?.length ? fallback : null);
};